/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Button, ButtonBaseActions, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { TriangleExclamationIcon, XIcon } from "../../FontAwesome";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";
import DialogBase from "../DialogBase";

interface UngespeicherteAenderungenDialogProps {
    isOpen: boolean;
    onVerwerfen: () => void;
    onSpeichern: () => void;
    onSchliessen: () => void;
}

export default function UngespeicherteAenderungenDialog(props: UngespeicherteAenderungenDialogProps) {
    const { t } = useTranslation();
    return (
        <DialogBase
            open={props.isOpen}
            onClose={props.onSchliessen}
            sx={theme => ({
                "& > .MuiDialog-container > .MuiPaper-root": {
                    borderLeft: `16px solid ${theme.palette.warning.dark}`,
                },
            })}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TriangleExclamationIcon sx={theme => ({ color: theme.palette.warning.dark })} />
                {t(translationKeys.cloudBrowserRouter.nichtGespeicherteAenderungen)}
            </DialogTitle>

            <IconButton
                onClick={props.onSchliessen}
                size="small"
                sx={theme => ({
                    marginLeft: "auto",
                    color: theme.palette.grey[500],
                    position: "absolute",
                    top: 8,
                    right: 8,
                })}
            >
                <XIcon fontSize="small" />
            </IconButton>

            <DialogContent>
                <DialogContentText>
                    {t(translationKeys.cloudBrowserRouter.moechtenSieDieAenderungenVerwerfen)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button action={(instance: ButtonBaseActions | null) => instance?.focusVisible()} onClick={props.onSpeichern}>
                    {t(translationKeys.cloudBrowserRouter.speichern)}
                </Button>
                <Button onClick={props.onVerwerfen}>
                    {t(translationKeys.cloudBrowserRouter.verwerfen)}
                </Button>
            </DialogActions>
        </DialogBase>
    );
}